import moment from "moment";
import { uploadUserImage } from "./redux/actions/AdminActions";


const colorMap = new Map();
const colors = [
  'badge-primary',
  'badge-danger',
  'badge-success',
  'badge-warning',
  'badge-info',
  'bg-soft-pink',
  'bg-soft-yellow',
  'bg-soft-cyan',
  'bg-soft-purple',
];
const colorss = [
  'primary',
  'danger',
  'success',
  'warning',
  'info',
];

let colorIndex = 0;

export const getColorForValue = (value: any) => {
  if (!value) return 'badge-secondary';
  if (colorMap.has(value)) {
    return colorMap.get(value);
  }
  const color = colors[colorIndex % colors.length];
  colorMap.set(value, color);
  colorIndex++;
  return color;
};
export const getColor = (value: any) => {
  if (!value) return 'secondary';
  if (colorMap.has(value)) {
    return colorMap.get(value);
  }
  const color = colorss[colorIndex % colorss.length];
  colorMap.set(value, color);
  colorIndex++;
  return color;
};
export function getTimeDifference(dueDate: any) {
  if (!dueDate) return '';

  const dueDateTime = new Date(dueDate).getTime();
  const currentTime = Date.now();
  const differenceInMs = currentTime - dueDateTime;

  const seconds = Math.floor(differenceInMs / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const weeks = Math.floor(days / 7);
  const months = Math.floor(days / 30);
  const years = Math.floor(days / 365);

  if (years > 0) return `${years} year${years > 1 ? 's' : ''} ago`;
  if (months > 0) return `${months} month${months > 1 ? 's' : ''} ago`;
  if (weeks > 0) return `${weeks} week${weeks > 1 ? 's' : ''} ago`;
  if (days > 0) return `${days} day${days > 1 ? 's' : ''} ago`;
  if (hours > 0) return `${hours} hour${hours > 1 ? 's' : ''} ago`;
  if (minutes > 0) return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
  return `just now`;
}
export const capitalizeFirstLetter = (input: string) => {
  return input ? input.slice(0, 1).toUpperCase().concat(input.slice(1, input.length)) : "";
}
export const downloadContents = (file: any) => {
  if (!file || !file.data || !file.name) {
    console.error("Invalid file data");
    return;
  }

  // Convert base64 or binary string data to a Blob
  const byteCharacters = atob(file.data);
  const byteNumbers = Array.from(byteCharacters, (char) => char.charCodeAt(0));
  const byteArray = new Uint8Array(byteNumbers);

  // Determine MIME type based on file extension
  const mimeTypeMap: { [key: string]: string } = {
    pdf: 'application/pdf',
    jpeg: 'image/jpeg',
    jpg: 'image/jpg',
    png: 'image/png',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    mp3: 'audio/mp3',
    mp4: 'video/mp4',
    webm: 'video/webm',
  };

  const fileExtension = file.name.split('.').pop()?.toLowerCase() || '';
  const mimeType = mimeTypeMap[fileExtension] || 'application/octet-stream';

  const blob = new Blob([byteArray], { type: mimeType });

  // Create a download link
  const downloadUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.download = file.name;
  link.click();

  // Clean up the URL object
  URL.revokeObjectURL(downloadUrl);
};

export const groupByDateTime = (files: any) => {
  return files?.reduce((grouped: any, file: any) => {
    const key = moment(file.uploadedAt).format("DD MMM YYYY hh:mm");
    if (!grouped[key]) {
      grouped[key] = [];
    }
    grouped[key].push(file);
    return grouped;
  }, {});
};
export const handleImageUpload = async (event: any, dispatch: any) => {
  const docfile = event.target.files[0];
  if (docfile) {
    const formData = new FormData();
    formData.append("docs[0].file", docfile);
    formData.append("docs[0].type", "image");
    await dispatch(uploadUserImage(formData))
  }

};

export async function compressWebM(videoBlob: Blob, targetBitrate = 1000000): Promise<Blob> {
  return new Promise<Blob>((resolve, reject) => {
    const video = document.createElement('video');
    video.src = URL.createObjectURL(videoBlob);
    video.preload = 'metadata';
    video.muted = false; 
    video.crossOrigin = 'anonymous'; 

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    video.onloadedmetadata = async () => {
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      video.play();


      const videoStream = canvas.captureStream(30);


      const audioContext = new AudioContext();
      const source = audioContext.createMediaElementSource(video);
      const destination = audioContext.createMediaStreamDestination();
      source.connect(destination);
      source.connect(audioContext.destination);

      const audioStream = destination.stream;

      const mixedStream = new MediaStream([
        ...videoStream.getVideoTracks(),
        ...audioStream.getAudioTracks(),
      ]);

      const recorder = new MediaRecorder(mixedStream, {
        mimeType: 'video/webm; codecs=vp9,opus', 
        videoBitsPerSecond: targetBitrate,
      });

      const chunks: BlobPart[] = [];

      recorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          chunks.push(event.data);
        }
      };

      recorder.onstop = () => {
        resolve(new Blob(chunks, { type: 'video/webm' }));
      };

      recorder.start();

      function drawFrame() {
        if (video.paused || video.ended) {
          recorder.stop();
          return;
        }
        ctx?.drawImage(video, 0, 0, canvas.width, canvas.height);
        requestAnimationFrame(drawFrame);
      }

      drawFrame();
    };

    video.onerror = (e) => reject(new Error('Video load error: ' + e));
  });
}


export async function compressAudio(audioBlob: Blob, targetSizeBytes: number = 1024 * 1024): Promise<Blob> {
  return new Promise<Blob>(async (resolve, reject) => {
      try {
          const audioContext = new AudioContext();
          const arrayBuffer = await audioBlob.arrayBuffer();
          const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

          const downsampledBuffer = await downsampleAudioBuffer(audioBuffer, 16000); // 16kHz
          const reducedBitDepthBuffer = await reduceBitDepth(downsampledBuffer, 8); // 8-bit

          const wavBuffer = await audioBufferToWav(reducedBitDepthBuffer);
          const newBlob = new Blob([wavBuffer], { type: 'audio/wav' });

          resolve(newBlob);

      } catch (error) {
          reject(error);
      }
  });
}
async function downsampleAudioBuffer(buffer: AudioBuffer, targetSampleRate: number): Promise<AudioBuffer> {
  const offlineAudioContext = new OfflineAudioContext(buffer.numberOfChannels, buffer.length * (targetSampleRate / buffer.sampleRate), targetSampleRate);
  const source = offlineAudioContext.createBufferSource();
  source.buffer = buffer;
  source.connect(offlineAudioContext.destination);
  source.start();
  return new Promise(resolve => {
      offlineAudioContext.oncomplete = event => resolve(event.renderedBuffer);
      offlineAudioContext.startRendering();
  });
}

async function reduceBitDepth(buffer: AudioBuffer, targetBitDepth: number): Promise<AudioBuffer> {
  const newBuffer = new AudioBuffer({
      numberOfChannels: buffer.numberOfChannels,
      length: buffer.length,
      sampleRate: buffer.sampleRate,
  });

  for (let channel = 0; channel < buffer.numberOfChannels; channel++) {
      const inputData = buffer.getChannelData(channel);
      const outputData = newBuffer.getChannelData(channel);

      for (let i = 0; i < inputData.length; i++) {
          const sample = inputData[i];
          const quantizedSample = Math.round(sample * ((2 ** (targetBitDepth - 1)) - 1)) / ((2 ** (targetBitDepth - 1)) - 1);
          outputData[i] = quantizedSample;
      }
  }

  return newBuffer;
}
async function audioBufferToWav(buffer: AudioBuffer): Promise<ArrayBuffer> {
  const numberOfChannels = buffer.numberOfChannels;
  const sampleRate = buffer.sampleRate;
  const length = buffer.length;

  const arrayBuffer = new ArrayBuffer(44 + length * numberOfChannels * 2);
  const view = new DataView(arrayBuffer);

  // RIFF header
  writeString(view, 0, 'RIFF');
  view.setUint32(4, 36 + length * numberOfChannels * 2, true);
  writeString(view, 8, 'WAVE');

  // fmt chunk
  writeString(view, 12, 'fmt ');
  view.setUint32(16, 16, true);
  view.setUint16(20, 1, true); // PCM format
  view.setUint16(22, numberOfChannels, true);
  view.setUint32(24, sampleRate, true);
  view.setUint32(28, sampleRate * numberOfChannels * 2, true); // byte rate
  view.setUint16(32, numberOfChannels * 2, true); // block align
  view.setUint16(34, 16, true); // bits per sample

  // data chunk
  writeString(view, 36, 'data');
  view.setUint32(40, length * numberOfChannels * 2, true);

  floatTo16BitPCM(view, 44, buffer);

  return arrayBuffer;
}

function writeString(view: DataView, offset: number, string: string) {
  for (let i = 0; i < string.length; i++) {
      view.setUint8(offset + i, string.charCodeAt(i));
  }
}

function floatTo16BitPCM(output: DataView, offset: number, input: AudioBuffer) {
  for (let i = 0; i < input.length; i++, offset += 2) {
      const s = Math.max(-1, Math.min(1, input.getChannelData(0)[i]));
      output.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
  }
}
export const getGreeting = () => {
  const currentHour = new Date().getHours();

  if (currentHour >= 5 && currentHour < 12) {
    return 'Good Morning 👋';
  } else if (currentHour >= 12 && currentHour < 17) {
    return 'Good Afternoon 👋';
  } else {
    return 'Good Evening 👋';
  }
};